import { NgModule } from '@angular/core';
//import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';
import { MenuModule } from 'primeng/menu';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenubarModule } from 'primeng/menubar';
import { AccordionModule } from 'primeng/accordion';
import { DatePipe } from '@angular/common';
import { NgChartsModule  } from 'ng2-charts';
import { CarouselModule } from 'primeng/carousel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { MatBadgeModule } from '@angular/material/badge';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';

const modules = [
  MatCardModule,
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatDialogModule,
  //FlexLayoutModule,
  DropdownModule,
  InputTextModule,
  KeyFilterModule,
  FieldsetModule,
  ButtonModule,
  InputTextareaModule,
  CheckboxModule,
  TableModule,
  MultiSelectModule,
  ProgressBarModule,
  TooltipModule,
  MessageModule,
  TabViewModule,
  PanelModule,
  MenuModule,
  MegaMenuModule,
  MenubarModule,
  AccordionModule,
  MatCheckboxModule,
  MatSelectModule,
  NgChartsModule ,
  CarouselModule,
  OverlayPanelModule,
  CalendarModule,
  MatBadgeModule,
  TriStateCheckboxModule
]

@NgModule({
  imports: modules,
  exports: modules,
  declarations: [],
  providers: [ DatePipe,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, hasBackdrop: true, autoFocus: true } }
  ]
})
export class SharedLibsModule { }
